import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { BPTQuestion } from '@/models/bpt.model';

class BPTQuestionsService extends BaseService {
  private url: string = '/api/bpt-question';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<BPTQuestion>> {
    const res = await this.$http.get<BPTQuestion>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<BPTQuestion[]>> {
    const res = await this.$http.get<BPTQuestion[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(
    item: Partial<BPTQuestion>,
  ): Promise<DataResponse<BPTQuestion>> {
    const res = await this.$http.post<BPTQuestion>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: BPTQuestion): Promise<DataResponse<BPTQuestion>> {
    const res = await this.$http.put<BPTQuestion>(
      `${this.url}/${item.id}`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async updateOrder(
    order: number[],
  ): Promise<DataResponse<BPTQuestion[]>> {
    const res = await this.$http.put<BPTQuestion[]>(
      `${this.url}/order`,
      order.map((id, index) => ({ id, index })),
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new BPTQuestionsService();
